export enum PORTALTYPE {
    ADMIN = 'admin',
    EMPLOYEE = 'employee',
    NBFC = 'NBFC Authority',
    NBFCEmployee = 'NBFC Employee'
};